import { useTariffStore } from '@/store/tariffStore'
import { resolveFeatureGate } from '@/services/tariffs/tariffGateResolver'

// quiz.* keys resolve against the open quiz's tariff subject (owner tariff for
// collaborators on shared quizzes); every other scope uses the signed-in user.
export function useTariffGate(options = {}) {
    const store = useTariffStore()
    const subject = store.resolveTariffSubject(options.featureKey)

    return resolveFeatureGate({
        ...options,
        accessMap: subject.accessMap,
        usageMap: subject.usageMap,
        isLoading: subject.isLoading,
        isUnavailable: subject.isUnavailable,
    })
}
